<template>
  <div id="OnlinePaymentReport">
    <net-pa-list-page-card
      title="گزارش کلیه پرداخت های اینترنتی (خود و افراد وابسته)"
      description="از طریق این فرم می‌توانید ریز گزارشات پرداختی اینترنتی خود و افراد وابسته از طریق اینترنت بانک را مشاهده کنید"
      :show-back="true"
    >
      <div class="OnlinePaymentReport-filters">
        <div class="OnlinePaymentReport-field OnlinePaymentReport-date">
          <small class="OnlinePaymentReport-label">از تاریخ</small>
          <date-picker
            :editable="true"
            :auto-submit="true"
            :max="TaTarix"
            color="#435ebe"
            v-model="AzTarixSahebHesab"
          ></date-picker>
          <input
            type="text"
            tabindex="-1"
            class="d-none InputText"
            style="direction: ltr"
          />
        </div>
        <div class="OnlinePaymentReport-field OnlinePaymentReport-date">
          <small class="OnlinePaymentReport-label">تا تاریخ</small>
          <date-picker
            :editable="true"
            :auto-submit="true"
            :min="AzTarix"
            color="#435ebe"
            v-model="TaTarixSahebHesab"
          ></date-picker>
          <input
            type="text"
            tabindex="-1"
            class="d-none InputText"
            style="direction: ltr"
          />
        </div>
        <div class="OnlinePaymentReport-field OnlinePaymentReport-action">
          <small
            class="OnlinePaymentReport-label OnlinePaymentReport-label--spacer"
            aria-hidden="true"
            >&nbsp;</small
          >
          <input
            type="button"
            value="جستجو"
            class="btn btn-success w-100 OnlinePaymentReport-search-btn"
            @click="
              SearchsahebHesab();
              $ResetTimer();
            "
          />
        </div>
      </div>
      <vue-bootstrap4-table
        :rows="rows2"
        :columns="columns2"
        :config="config"
        :classes="classes"
      >
        <template slot="sort-asc-icon">
          <i class="fa fa-sort-up"></i>
        </template>
        <template slot="sort-desc-icon">
          <i class="fa fa-sort-down"></i>
        </template>
        <template slot="no-sort-icon">
          <i class="fa fa-sort"></i>
        </template>
        <template slot="empty-results">
          <p class="text-right">اطلاعاتی یافت نشد</p>
        </template>
        <template slot="row" slot-scope="props">
          <p class="text-center">{{ props.row.vbt_id }}</p>
        </template>
        <template slot="bestan" slot-scope="props">
          <p class="text-center">{{ $Comma3ragham(props.row.bestan) }}</p>
        </template>
        <template slot="Action" slot-scope="props">
          <small>
            <div
              class="btn Pointer btn-outline-info OnlinePaymentReport-detail-btn"
              @click="openPaymentDetail(props.row)"
              data-toggle="modal"
              data-target="#ModalBanafash"
            >
              <i class="fas fa-list ml-2"></i> جزئیات
            </div>
          </small>
        </template>
      </vue-bootstrap4-table>
    </net-pa-list-page-card>
    <modal-custom v-if="$store.state.renderComponent">
      <template v-slot:ContentModalBanafash>
        <div class="online-payment-detail-modal" dir="rtl">
          <div class="online-payment-detail-modal__header">
            <div class="online-payment-detail-modal__intro">
              <div class="online-payment-detail-modal__intro-text">
                <h6 class="online-payment-detail-modal__title">
                  <i class="fas fa-receipt ml-2"></i>
                  جزئیات پرداخت اینترنتی
                </h6>
                <p
                  v-if="detailModalSubtitle"
                  class="online-payment-detail-modal__subtitle"
                >
                  {{ detailModalSubtitle }}
                </p>
              </div>
              <button
                type="button"
                class="online-payment-detail-modal__close close"
                data-dismiss="modal"
                aria-label="بستن"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              v-if="selectedPayment"
              class="online-payment-detail-modal__summary"
            >
              <div class="online-payment-detail-modal__summary-item">
                <span class="online-payment-detail-modal__summary-label"
                  >تاریخ سند</span
                >
                <span class="online-payment-detail-modal__summary-value">{{
                  selectedPayment.tarixSanad || "—"
                }}</span>
              </div>
              <div class="online-payment-detail-modal__summary-item">
                <span class="online-payment-detail-modal__summary-label"
                  >کد رهگیری</span
                >
                <span
                  class="online-payment-detail-modal__summary-value"
                  dir="ltr"
                  >{{ selectedPayment.codeRahgiri || "—" }}</span
                >
              </div>
              <div class="online-payment-detail-modal__summary-item">
                <span class="online-payment-detail-modal__summary-label"
                  >مبلغ کل</span
                >
                <span class="online-payment-detail-modal__summary-value">{{
                  $Comma3ragham(selectedPayment.bestan)
                }}</span>
              </div>
            </div>
          </div>

          <div
            class="online-payment-detail-modal__table-wrap table-responsive"
          >
            <vue-bootstrap4-table
              :rows="rows3"
              :columns="columns3"
              :config="detailModalConfig"
              :classes="detailModalClasses"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="online-payment-detail-modal__empty">
                  ریز پرداختی یافت نشد
                </p>
              </template>
              <template slot="mablagh" slot-scope="props">
                <span class="online-payment-detail-modal__amount">{{
                  props.cell_value
                }}</span>
              </template>
              <template slot="vCode" slot-scope="props">
                <span dir="ltr">{{ props.cell_value }}</span>
              </template>
            </vue-bootstrap4-table>
          </div>

          <div
            v-if="rows3.length"
            class="online-payment-detail-modal__footer"
          >
            <span class="online-payment-detail-modal__footer-label">
              مجموع ریز پرداخت‌ها:
              <strong>{{ $Comma3ragham(detailTotalMablagh) }}</strong>
              {{ $GetVahedPool() }}
            </span>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
export default {
  components: {
    NetPaListPageCard,
    VueBootstrap4Table,
    ModalCustom,
  },
  data() {
    return {
      AzTarix: "",
      TaTarix: "",

      AzTarixSahebHesab: "",
      TaTarixSahebHesab: "",

      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GozareshParForWeb",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRow_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GozareshParForWeb/GetGozareshSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRow_Detaile: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GozareshParForWeb/Detaile",
        Token: this.$session.get("TokenNetPa"),
      },
      rows: [],
      rows2: [],
      rows3: [],
      selectedPayment: null,
      detailTotalMablagh: 0,
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "عنوان تسهیلات",
          name: "desNoe",
        },
        {
          label: "شماره تسهیلات",
          name: "vCode",
        },
        {
          label: "مبلغ واریزی",
          name: "bestan",
        },
        {
          label: "زمان تراکنش",
          name: "zamanInsert",
        },
        {
          label: "تاریخ سند",
          name: "tarixSanad",
        },
        {
          label: "کد رهگیری",
          name: "codeRahgiri",
        },
        {
          label: "شرح واریزی",
          name: "sharhSanad",
        },
      ],
      columns2: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "شرح واریزی",
          name: "sharh",
        },
        {
          label: "تاریخ سند",
          name: "tarixSanad",
        },
        {
          label: "کد رهگیری",
          name: "codeRahgiri",
        },
        {
          label: "مبلغ کل واریزی",
          name: "bestan",
        },
        {
          label: "عملیات",
          name: "Action",
        },
      ],
      columns3: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "مبلغ واریزی",
          name: "mablagh",
        },
        {
          label: "شماره حساب/تسهیلات",
          name: "vCode",
        },
        {
          label: "عنوان حساب/تسهیلات",
          name: "desNoe",
        },
        {
          label: "مشخصات",
          name: "namefamily",
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "  جستجو مبلغ و کد رهگیری",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      detailModalConfig: {
        pagination: true,
        pagination_info: false,
        per_page: 5,
        per_page_options: [5, 10, 20],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "جستجو در ریز پرداخت‌ها",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 500,
        },
      },
      detailModalClasses: {
        table: "table table-hover online-payment-detail-modal-table",
      },
    };
  },
  computed: {
    detailModalSubtitle() {
      if (!this.selectedPayment) return "";
      return this.selectedPayment.sharh || "";
    },
  },
  mounted() {
    this.SearchsahebHesab();
  },
  methods: {
    SearchGardesh() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId
      );
      formData.append("AzTarix", this.AzTarix);
      formData.append("TaTarix", this.TaTarix);
      this.DataAxiosRow.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow).then((data) => {
        this.rows = data.result;
      });
    },
    SearchsahebHesab() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId
      );
      formData.append("AzTarix", this.AzTarixSahebHesab);
      formData.append("TaTarix", this.TaTarixSahebHesab);
      this.DataAxiosRow_SahebHesab.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow_SahebHesab).then((data) => {
        this.rows2 = data.result;
      });
    },
    openPaymentDetail(row) {
      this.selectedPayment = row;
      this.Detaile(row.id);
    },
    Detaile(id) {
      let info;
      let list = [];
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });

      const applyDetail = (result) => {
        this.detailTotalMablagh = result.reduce(
          (sum, item) => sum + (Number(item.mablagh) || 0),
          0
        );
        for (let index = 0; index < result.length; index++) {
          info = result[index];
          info["row"] = index + 1;
          list.push(info);
        }
        this.rows3 = this.$FormatMablaghGrid(list);
      };

      const formData = new FormData();
      formData.append("wwwtblVarizGorohiId", id);
      this.DataAxiosRow_Detaile.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow_Detaile).then((data) => {
        applyDetail(data.result);
      });
    },
  },
};
</script>
<style scoped>
.OnlinePaymentReport-filters {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1.5rem;
}
.OnlinePaymentReport-field {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: right;
  min-width: 0;
}
.OnlinePaymentReport-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  line-height: 1.25rem;
  font-size: 13px !important;
  font-weight: 600;
  color: #2a3f54;
}
.OnlinePaymentReport-label--spacer {
  visibility: hidden;
  user-select: none;
}
.OnlinePaymentReport-date {
  flex: 1 1 40%;
}
.OnlinePaymentReport-action {
  flex: 0 0 8.5rem;
}
.OnlinePaymentReport-date >>> .vpd-main {
  display: block;
  width: 100%;
}
.OnlinePaymentReport-date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  height: calc(1.5em + 0.75rem + 2px);
}
.OnlinePaymentReport-date >>> .vpd-input-group input {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  min-height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  line-height: 1.5;
}
.OnlinePaymentReport-search-btn {
  min-height: calc(1.5em + 0.75rem + 2px);
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .OnlinePaymentReport-filters {
    flex-wrap: wrap;
  }
  .OnlinePaymentReport-date {
    flex: 1 1 100%;
  }
  .OnlinePaymentReport-action {
    flex: 1 1 100%;
  }

  #OnlinePaymentReport .OnlinePaymentReport-detail-btn {
    padding: 0.2rem 0.45rem;
    font-size: 11px !important;
    line-height: 1.3;
    border-radius: 6px;
    white-space: nowrap;
  }

  #OnlinePaymentReport .OnlinePaymentReport-detail-btn .fa-list {
    font-size: 10px;
    margin-left: 0.25rem !important;
  }
}

#OnlinePaymentReport >>> #ModalBanafash .modal-dialog {
  margin: 1.25rem auto;
  max-width: min(920px, calc(100vw - 2rem));
  width: calc(100% - 2rem);
}

#OnlinePaymentReport >>> #ModalBanafash .modal-content {
  background: #fff !important;
  border: none;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
}

#OnlinePaymentReport >>> #ModalBanafash .modal-header.bg {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  overflow: hidden;
}

#OnlinePaymentReport >>> #ModalBanafash .modal-body {
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  overflow: hidden;
}

#OnlinePaymentReport .online-payment-detail-modal {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  background: #fff;
  text-align: right;
  border-radius: 14px;
  overflow: hidden;
}

#OnlinePaymentReport .online-payment-detail-modal__header {
  flex-shrink: 0;
  padding: 0.75rem 0.85rem 0.65rem;
  border-bottom: 1px solid #e8ecf1;
}

#OnlinePaymentReport .online-payment-detail-modal__intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
}

#OnlinePaymentReport .online-payment-detail-modal__intro-text {
  flex: 1 1 auto;
  min-width: 0;
}

#OnlinePaymentReport .online-payment-detail-modal__close {
  flex-shrink: 0;
  align-self: flex-start;
  float: none;
  margin: 0 0 0 -0.45rem;
  padding: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  color: #2a3f54 !important;
  opacity: 1;
  text-shadow: none;
  font-size: 1.35rem;
  line-height: 1;
}

#OnlinePaymentReport .online-payment-detail-modal__close:hover {
  background: rgba(42, 63, 84, 0.14);
  color: #1a2a3a !important;
}

#OnlinePaymentReport .online-payment-detail-modal__close:focus,
#OnlinePaymentReport .online-payment-detail-modal__close:focus-visible,
#OnlinePaymentReport .online-payment-detail-modal__close:active {
  outline: none !important;
  box-shadow: none !important;
}

#OnlinePaymentReport .online-payment-detail-modal__title {
  margin: 0;
  min-width: 0;
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#OnlinePaymentReport .online-payment-detail-modal__title .fa-receipt {
  color: #2563eb;
}

#OnlinePaymentReport .online-payment-detail-modal__subtitle {
  margin: 0.35rem 0 0;
  font-size: 12px !important;
  font-weight: 600;
  color: #6c757d;
  line-height: 1.4;
}

#OnlinePaymentReport .online-payment-detail-modal__summary {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
  margin-top: 0.55rem;
}

#OnlinePaymentReport .online-payment-detail-modal__summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  min-height: 2.35rem;
  background: #f8fafc;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  padding: 0.5rem 0.65rem;
  min-width: 0;
}

#OnlinePaymentReport .online-payment-detail-modal__summary-label {
  flex-shrink: 0;
  font-size: 12px !important;
  font-weight: 600;
  color: #6c757d;
  margin: 0;
  white-space: nowrap;
}

#OnlinePaymentReport .online-payment-detail-modal__summary-value {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px !important;
  font-weight: 700;
  color: #2a3f54;
  text-align: left;
  margin: 0;
  word-break: break-word;
}

#OnlinePaymentReport .online-payment-detail-modal__table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.5rem 0.75rem 0.35rem;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

#OnlinePaymentReport
  .online-payment-detail-modal__table-wrap
  >>> .vbt-table-wrapper {
  overflow-x: auto;
  overflow-y: visible;
  max-height: none;
}

#OnlinePaymentReport .online-payment-detail-modal-table {
  margin-bottom: 0;
  font-size: 13px !important;
}

#OnlinePaymentReport .online-payment-detail-modal-table thead th {
  background: #f0f2f5;
  color: #2a3f54;
  font-weight: 700;
  border-color: #e8ecf1;
  white-space: nowrap;
}

#OnlinePaymentReport .online-payment-detail-modal-table tbody td {
  vertical-align: middle;
  color: #2a3f54;
}

#OnlinePaymentReport .online-payment-detail-modal__amount {
  font-weight: 700;
  color: #15803d;
}

#OnlinePaymentReport .online-payment-detail-modal__empty {
  margin: 0;
  padding: 1.5rem 0;
  text-align: center;
  color: #6c757d;
}

#OnlinePaymentReport .online-payment-detail-modal__footer {
  flex-shrink: 0;
  padding: 0.65rem 0.75rem 0.75rem;
  border-top: 1px solid #e8ecf1;
  background: #fafbfc;
  text-align: right;
}

#OnlinePaymentReport .online-payment-detail-modal__footer-label {
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#OnlinePaymentReport .online-payment-detail-modal__footer-label strong {
  font-size: 16px !important;
  font-weight: 800;
  color: #15803d;
}

#OnlinePaymentReport
  .online-payment-detail-modal__table-wrap
  >>> .vbt-global-search-wrapper {
  max-width: 20rem;
}

@media (max-width: 767px) {
  #OnlinePaymentReport >>> #ModalBanafash .modal-dialog {
    margin: 0.5rem auto;
    width: calc(100% - 0.75rem);
    max-width: calc(100% - 0.75rem);
  }

  #OnlinePaymentReport >>> #ModalBanafash .modal-content,
  #OnlinePaymentReport >>> #ModalBanafash .modal-body,
  #OnlinePaymentReport .online-payment-detail-modal {
    max-height: min(calc(100dvh - 1rem), calc(100vh - 1rem));
  }

  #OnlinePaymentReport .online-payment-detail-modal__header {
    padding: 0.6rem 0.65rem 0.5rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__intro {
    gap: 0.45rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__close {
    width: 28px;
    height: 28px;
    margin-left: -0.35rem;
    font-size: 1.2rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__title {
    font-size: 14px !important;
    line-height: 1.35;
  }

  #OnlinePaymentReport .online-payment-detail-modal__subtitle {
    margin-top: 0.25rem;
    font-size: 11px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary {
    margin-top: 0.45rem;
    gap: 0.35rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary-item {
    min-height: 2.15rem;
    padding: 0.45rem 0.55rem;
    border-radius: 6px;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary-label {
    font-size: 11px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary-value {
    font-size: 12px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__table-wrap {
    padding: 0.4rem 0.55rem 0.25rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal-table {
    font-size: 12px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__footer {
    padding: 0.55rem 0.55rem 0.6rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__footer-label {
    font-size: 14px !important;
    font-weight: 700;
    line-height: 1.45;
  }

  #OnlinePaymentReport .online-payment-detail-modal__footer-label strong {
    font-size: 15px !important;
    font-weight: 800;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .vbt-table-tools {
    --vbt-search-max-width: 100%;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .vbt-global-search-wrapper {
    max-width: 100%;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .footer-pagination-row > td {
    padding: 0.55rem 0.45rem !important;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .vbt-pagination-row .pagination {
    justify-content: center;
    gap: 0.25rem;
  }
}
</style>
